import { CustomErrorClass, ErrorSeverity } from '../../errors';
import { RESPONSE_MESSAGE_TYPES } from '../../constants';
const messageTypeMap = {
    image: (msg) => { var _a; return ((_a = msg === null || msg === void 0 ? void 0 : msg.attachment) === null || _a === void 0 ? void 0 : _a.type) === RESPONSE_MESSAGE_TYPES.IMAGE; },
    accordion: (msg) => (msg === null || msg === void 0 ? void 0 : msg.type) === RESPONSE_MESSAGE_TYPES.ACCORDION,
    carousel: (msg) => (msg === null || msg === void 0 ? void 0 : msg.type) === RESPONSE_MESSAGE_TYPES.CAROUSEL,
    quickReply: (msg) => { var _a; return ((_a = msg === null || msg === void 0 ? void 0 : msg.quick_replies) === null || _a === void 0 ? void 0 : _a.length) > 0; },
    fileDownload: (msg) => (msg === null || msg === void 0 ? void 0 : msg.type) === RESPONSE_MESSAGE_TYPES.FILE_DOWNLOAD,
    video: (msg) => (msg === null || msg === void 0 ? void 0 : msg.type) === RESPONSE_MESSAGE_TYPES.VIDEO,
    csat: (msg) => (msg === null || msg === void 0 ? void 0 : msg.type) === RESPONSE_MESSAGE_TYPES.CSAT,
    text: (msg) => msg.text && msg.type === undefined,
    rating: (msg) => (msg === null || msg === void 0 ? void 0 : msg.type) === RESPONSE_MESSAGE_TYPES.RATING,
};
export const determineMessageType = (message) => {
    for (const [key, guard] of Object.entries(messageTypeMap)) {
        if (guard(message)) {
            return key;
        }
    }
    throw new CustomErrorClass(ErrorSeverity.Error, "Can't load new message", `Message type not implemented MESSAGE: ${message}`);
};
//# sourceMappingURL=determine-message-type.js.map